export function getURLParams() {
    const url = window.location.href;
    let params = url.split('?')[1];
    const paramsObj = {};
    if (params) {
        params = params.split('&');
        params.forEach((param) => {
            const [key, value] = param.split('=');
            paramsObj[key] = value;
        });
    }
    return paramsObj;
}
export function setURLParams(params) {
    const url = window.location.href;
    let paramsStr = '';
    for (const key in params) {
        paramsStr += `${key}=${params[key]}&`;
    }
    paramsStr = paramsStr.slice(0, -1);
    window.history.pushState({}, '', `${url.split('?')[0]}?${paramsStr}`);
}
export function removeAllURLParams() {
    const url = window.location.href;
    window.history.pushState({}, '', url.split('?')[0]);
}
export function removeURLParam(param) {
    const params = getURLParams();
    const filteredParams = Object.fromEntries(Object.entries(params).filter(([key]) => key !== param));
    setURLParams(filteredParams);
}
export function getURLParam(param) {
    return getURLParams()[param];
}
export function setURLParam(param, value) {
    const params = getURLParams();
    params[param] = value;
    setURLParams(params);
}
export function updateURLParam(param, value) {
    setURLParam(param, value);
}
